type KeyName =
  | 'break'
  | 'backspace'
  | 'tab'
  | 'clear'
  | 'enter'
  | 'shift'
  | 'ctrl'
  | 'alt'
  | 'pause'
  | 'capslock'
  | 'hangul'
  | 'hanja'
  | 'escape'
  | 'conversion'
  | 'non-conversion'
  | 'spacebar'
  | 'pageUp'
  | 'pageDown'
  | 'end'
  | 'home'
  | 'arrowLeft'
  | 'arrowUp'
  | 'arrowRight'
  | 'arrowDown'
  | 'select'
  | 'print'
  | 'execute'
  | 'printScreen'
  | 'insert'
  | 'delete'
  | 'help'
  | 'plus'
  | 'number';

const KEY_MAP = new Map<KeyName, number | [number, number]>([
  ['break', 3],
  ['backspace', 8],
  ['tab', 9],
  ['clear', 12],
  ['enter', 13],
  ['shift', 16],
  ['ctrl', 17],
  ['alt', 18],
  ['pause', 19],
  ['capslock', 20],
  ['hangul', 21],
  ['hanja', 25],
  ['escape', 27],
  ['conversion', 28],
  ['non-conversion', 29],
  ['spacebar', 32],
  ['pageUp', 33],
  ['pageDown', 34],
  ['end', 35],
  ['home', 36],
  ['arrowLeft', 37],
  ['arrowUp', 38],
  ['arrowRight', 39],
  ['arrowDown', 40],
  ['select', 41],
  ['print', 42],
  ['execute', 43],
  ['printScreen', 44],
  ['insert', 45],
  ['delete', 46],
  ['help', 47],
  ['plus', 187],
  ['number', [48, 57]]
]);

export const Keys = {
  is(e: { keyCode: number }, expectedKey: KeyName) {
    const number = KEY_MAP.get(expectedKey);
    if (typeof number === 'number') {
      return e.keyCode === number;
    }
    return e.keyCode >= (number?.[0] ?? 0) && e.keyCode <= (number?.[1] ?? 0);
  },
  isOneOf(e: { keyCode: number }, expectedKeys: KeyName[]) {
    return expectedKeys.map((k) => Keys.is(e, k)).includes(true);
  }
};
